/*
  mezuzi, theme 169.0 (#100) — keep Tab inside the open cart drawer.

  Since 166.0 #75 the cart is a MODAL dialog at every width, and Tinker's theme-drawer.js installs its
  JS focus trap only in the non-modal branch (open() / the mode switch: `showModal()` alone, relying on
  the browser). A native modal does not wrap Tab: after the last control focus leaves to the browser
  chrome (document.activeElement = <body>) once per round. The source's drawer keeps the loop inside
  (review-168/d87/carttab82.json). Read in review-169/PROPOSAL-100.md (tab100.mjs: re-trapping fixes it).

  Ours, not Tinker's file: a document keydown that acts only on Tab / Shift+Tab, only while the cart
  dialog is open AS A MODAL (in the non-modal branch Tinker's trapFocus owns it - no double wrap), only
  when focus is inside it and not inside another dialog / popover open within it. The focusable list is
  read at each keypress - so it is right after the content arrives and after every re-render while open
  (add / remove / quantity). Visible means rendered (a box, not visibility:hidden, not inert, not
  disabled, tabindex >= 0) - NOT opaque: the phone close is opacity 0 until :focus-visible (#98a, the
  source's rule), and Tab is how a keyboard user reaches it.
*/

const DIALOG = '#cart-drawer > dialog.cart-drawer__dialog';
const FOCUSABLE =
  "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe";

/**
 * @param {HTMLElement} element
 * @returns {boolean}
 */
function reachable(element) {
  if (element.tabIndex < 0 || element.closest('[inert]')) return false;
  if ('disabled' in element && element.disabled) return false;
  const box = element.getBoundingClientRect();
  if (box.width === 0 && box.height === 0) return false;
  return getComputedStyle(element).visibility !== 'hidden';
}

/** @param {KeyboardEvent} event */
function onKeyDown(event) {
  if (event.key !== 'Tab' || event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;

  const dialog = /** @type {HTMLDialogElement | null} */ (document.querySelector(DIALOG));
  if (!dialog || !dialog.open || !dialog.matches(':modal')) return;

  const active = document.activeElement;
  if (!(active instanceof HTMLElement) || !dialog.contains(active)) return;
  const nested = active.closest('dialog[open], :popover-open');
  if (nested && nested !== dialog) return;

  const focusable = /** @type {HTMLElement[]} */ ([...dialog.querySelectorAll(FOCUSABLE)]).filter(reachable);
  if (!focusable.length) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  if (!event.shiftKey && (active === last || active === dialog)) {
    event.preventDefault();
    first.focus();
  } else if (event.shiftKey && (active === first || active === dialog)) {
    event.preventDefault();
    last.focus();
  }
}

document.addEventListener('keydown', onKeyDown);
